import { render, staticRenderFns } from "./AssignmentSection.vue?vue&type=template&id=3b72a0ca&scoped=true"
import script from "./AssignmentSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssignmentSection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AssignmentSection.vue?vue&type=style&index=0&id=3b72a0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72a0ca",
  null
  
)

/* custom blocks */
import block0 from "./AssignmentSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MetricsProgressRing: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/ProgressRing.vue').default,MetricsFormattedMetricValue: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/FormattedMetricValue.vue').default})
